import ReportingFilter from "components/reportingFilter/ReportingFilter";
import React from "react";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";

import styles from "./embeddedVideoPerformance.module.scss";
import ReportingExport from "components/reportingExport/ReportingExport";
import { type AppDispatch, type RootState } from "features/Application/globaltypes/redux";
import { type ConnectedProps, connect } from "react-redux";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";
import { useAccountFilterShouldShow } from "features/Reporting/Content/queries/useAccountFilterShouldShow";
import { usePerformanceFilter } from "features/Library/Common/Hooks/usePerformanceFilter";
import EmbeddedVideoPerformanceBody from "./EmbeddedVideoPerformanceBody";

export type Props = PropsFromRedux & {
  embeddedVideoId: number;
  embeddedVideoTitle: string;
};

export const EmbeddedVideoPerformance: React.FC<Props> = ({
  embeddedVideoId,
  embeddedVideoTitle,
  accountId,
  accountType,
  publisherId,
}) => {
  const accountFilterShouldShow = useAccountFilterShouldShow(accountId, accountType, true);
  const [filter, setFilter] = usePerformanceFilter(
    {
      includeAccountsDropdown: accountFilterShouldShow,
      accountId,
      includeDistinct: true,
      supportsSPType: true,
    },
    publisherId,
  );
  const reportEnabled = !!useFeatureFlag(FeatureFlags.EmbeddedVideoReport);

  if (!reportEnabled) return <ReportUnavailable />;

  return (
    <div className={styles.body}>
      <div className={styles.header}>
        <h2>Summary</h2>
        <div className={styles.performanceHeader}>
          <ReportingFilter
            currentFilter={filter}
            callback={setFilter}
            includeDistinct
            includeAccounts={false}
            includeAccountsDropdown={accountFilterShouldShow}
            supportsSPType
            publisherId={publisherId}
          />
          <ReportingExport />
        </div>
      </div>
      <EmbeddedVideoPerformanceBody
        filter={filter}
        embeddedVideoTitle={embeddedVideoTitle}
        embeddedVideoId={embeddedVideoId}
        includeAccounts={!!filter.accounts?.length}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    accountId: state.userProfile.accountId,
    accountType: state.userProfile.accountTypeId,
    publisherId: state.library.embeddedVideos.details.embeddedVideo.publisherId,
  };
};

const mapDispatchToProps = (_dispatch: AppDispatch) => ({});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(EmbeddedVideoPerformance);
export default ConnectedComponent;
